import { ROUTES } from '@analyzer/utils/router/paths'
import { createAppRootRoute } from '@core/utils/router/create-app-root-route'

export const Route = createAppRootRoute(ROUTES.root)
